import React, { useState } from "react";
import SettingsLayout from "../../../layouts/SettingsLayout";
import SettingsHeading from "../../../settings/SettingsHeading";
import Employer from "../../../../apiResources/Employer";
import EmployerUser from "../../../../apiResources/EmployerUser";
import Loader from "../../../library/Loader";
import Divider from "../../../library/Divider";
import TermsDescriptionSettingsOption from "../../../settings/TermsDescriptionSettingsOption";
import TermsFileSettingsOption from "../../../settings/TermsFileSettingsOption";

const CustomTerms = (props: Props) => {
  const [editFocus, setEditFocus] = useState<string>(null);
  const { user, company } = props;

  const isDisabled = (value) => Boolean(editFocus) && editFocus !== value;
  const isEditing = (value) => Boolean(editFocus) && editFocus === value;

  if (!user || !company) {
    return (
      <SettingsLayout user={user}>
        <Loader />
      </SettingsLayout>
    );
  }

  return (
    <SettingsLayout user={user} company={company}>
      <SettingsHeading>Custom Terms</SettingsHeading>
      <TermsDescriptionSettingsOption
        user={user}
        company={company}
        disabled={isDisabled("description")}
        isEditing={isEditing("description")}
        onEditStart={() => setEditFocus("description")}
        onEditComplete={() => setEditFocus(null)}
      />
      <Divider />
      <TermsFileSettingsOption
        user={user}
        company={company}
        disabled={isDisabled("file")}
        isEditing={isEditing("file")}
        onEditStart={() => setEditFocus("file")}
        onEditComplete={() => setEditFocus(null)}
      />
    </SettingsLayout>
  );
};

type Props = {
  user: EmployerUser;
  company: Employer;
};

export default CustomTerms;
